import * as Yup from 'yup';

export const INITIAL_VALUES = {
  prize: 0,
};

export const FORM_VALIDATION_SCHEMA = Yup.object().shape({
  prize: Yup.number().required('Prize is required'),
});
